import { useCallback, useSyncExternalStore } from 'react';

/**
 * Whether a media query matches, kept current as the viewport changes. Read
 * synchronously on the first render, so what depends on it (a lazy part the
 * page only loads on wider screens, say) is decided before the first paint.
 * False where there is no matchMedia.
 */
export default function useMediaQuery(query) {
    const subscribe = useCallback((notify) => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
        const list = window.matchMedia(query);
        list.addEventListener?.('change', notify);

        return () => list.removeEventListener?.('change', notify);
    }, [query]);

    const matches = () => (
        typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches
    );

    return useSyncExternalStore(subscribe, matches, () => false);
}
